import { z } from "zod/v4";

export const UserHubspotTokenSchema = z.object({
  token: z.string(),
});

export type UserHubspotTokenType = z.infer<typeof UserHubspotTokenSchema>;
